<div *ngIf="isOpen() && config()" @fadeInOut
  class="fixed inset-0 w-full z-[999] bg-zinc-900/80 backdrop-blur-md flex flex-col justify-center items-center h-screen gap-2">
  <div #splashArt [ngClass]="{'animate-pulse': showPulseAnimation(), 'animate-ping': showPingAnimation() }"
    class="max-w-32">
    <img width="128" alt="splash-screen" [src]="imageUrl()" class="w-full" />
  </div>
  <span [ngClass]="{'opacity-0 transition-all duration-300': showPingAnimation()}"
    class="font-normal dark:text-white text-base md:text-lg">{{loadingText() | translate}}</span>

  <fv-button *ngIf="isDevEnvironment() || isHelperActivatedFlag()"
    class="fixed min-w-[95px] bottom-16 right-10 md:!right-16" (click)="close()" name="cache-button"
    [color]="BUTTON_COLOR.glassWhite" [size]="BUTTON_SIZE.sm" [type]="BUTTON_TYPE.outline">
    {{ 'global.hide' | translate}}
  </fv-button>
</div>